import { useQuery } from "@apollo/client";
import { graphql } from "~/gql";
import { GenerateWorkplanQuery } from "~/gql/graphql";

export const GENERATE_WORKPLAN = graphql(/* GraphQL */ `
  query generateWorkplan($matterId: Float!) {
    generateWorkplan(matterId: $matterId) {
      matterId
      matterTitle
      rates {
        id
        description
        feeEarner {
          id
          name
          feeEarnerLevel {
            id
            description
            order
          }
        }
        feeEarnerLevel {
          id
          description
          order
        }
      }
      lineItems {
        id
        title
        resourceAndTime {
          rateId
          timeRange {
            timeLower
            timeUpper
            timeSingle
          }
        }
      }
      resourceAndTimeTotals {
        rateId
        timeRange {
          timeLower
          timeUpper
          timeSingle
        }
      }
    }
  }
`);

export type Workplan = GenerateWorkplanQuery;
export function useWorkplanQuery(matterId: number) {
  return useQuery<Workplan>(GENERATE_WORKPLAN, {
    fetchPolicy: "no-cache",
    variables: { matterId },
  });
}
